import React, { Component } from 'react';
import BarChart from './charts/bar_chart'

class DashBoardContentTrainees extends Component {
  traineesComplianceRatingCharts(moduleComplianceRatings) {
    var barChart = []
    var labels = {
      "overall": "Overall Training Compliance (All Staff + Team Specific)",
      "all": "All Staff Compliance",
      "field": "Field Staff Compliance",
      "other": "Team Specific Compliance",
      "emergency": "Emergency Response - Project",
    }
    for(var key in moduleComplianceRatings) {
      if (moduleComplianceRatings[key].length === 0) continue
      barChart = barChart.concat(
        <div className="trainess-charts" key={key}>
          <BarChart key={ 'trainees-' + key } name={ 'trainee-compliance-' + key } data={ moduleComplianceRatings[key] } width={ 520 } height={ 500 } label={ labels[key] }/>
        </div>
      )
    }
    return barChart
  }

  render() {
    return (
      <div className="dashboard-content">
        { this.traineesComplianceRatingCharts(this.props.moduleComplianceRatings) }
        {
          this.props.loading &&
          <div className="loading-message">
            <i className="loading circle notched icon"></i>
            <span>Loading dashboard...</span>
          </div>
        }
      </div>
    )
  }
}

export default DashBoardContentTrainees;



// WEBPACK FOOTER //
// ./src/views/components/dashboard_content_trainees.js